/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { AutoComplete } from "antd";
import { useRouter } from "next/router";

import styles from "../../styles/FAQ.module.css";
import { AxiosInstance, logout } from "../../utilities";

const FaqSearchComponent = (props) => {
  const router = useRouter();

  const [selectedValue, setSelectedValue] = useState("");
  const [options, setOptions] = useState([]);

  const onSearch = (data) => {
    setSelectedValue(data);
    AxiosInstance(4008, "application/json")
      .get(`/faq/questions/${data}`)
      .then((resp) => {
        let response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          let responseData = [];
          response.data.map((value) => {
            responseData.push({
              label: value.question,
              value: value.slug,
              category: value.categorySlug,
            });
          });
          setOptions(responseData);
        }
      })
      .catch((err) => {
        var error = err && err.response;
        if (error && (error.status === "403" || error.status === 403)) {
          logout();
        } else {
          console.log("Error", error.msg);
        }
      });
  };

  const onSelect = (data, option) => {
    setSelectedValue(option.label);
    router.push(`/faq/${option.category}/${data}`);
  };

  const searchRequest = () => {
    router.push(`/faq/search?query=${selectedValue}`);
  };

  return (
    <div
      className={`d-flex align-items-center ${
        styles.faq_section_search_field
      } ${props.mainPage ? "mx-auto" : ""}`}
    >
      <AutoComplete
        className={`w-100 ${styles.faq_section_search_field_input}`}
        placeholder="Ask your Question..."
        onSearch={onSearch}
        onSelect={onSelect}
        options={options}
        value={selectedValue}
      />
      <button className={`img_btn ${styles.faq_section_search_field_btn}`}>
        <img
          src="/assets/images/search_icon_blue.svg"
          alt="search_icon"
          onClick={searchRequest}
        />
      </button>
    </div>
  );
};

export default FaqSearchComponent;
